module.exports = __webpack_public_path__ + "img/1_024.a48af1fa.jpg";